import { httpClient } from '@/services/http/httpClient'

type CreateCommentParams = {
  ideaId: string
  content: string
  file?: File
  commentIdToReply?: string
}

export async function createComment({
  ideaId,
  content,
  file,
}: CreateCommentParams): Promise<void> {
  const payload = new FormData()
  payload.append('ideaId', ideaId)
  payload.append('message', content)
  payload.append('type', 'NORMAL')
  if (file) {
    payload.append('file', file)
  }

  await httpClient.post(`/ideas/idea-comments`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
